export default () => ({
  testdrive: null
})



// WEBPACK FOOTER //
// ./src/store/modules/testdrive/state.js